import { DashboardOutlined, FileProtectOutlined, UserOutlined } from "@ant-design/icons";
import { MenuConfigItem } from "../../../../models/sistema/menuConfigItem";

export const caixa: MenuConfigItem[] = [
  {
    label: "PAINEL GERAL",
    key: "/painelGeral",
    path: "/painelGeral",
    icon: <DashboardOutlined />,
  },
  {
    label: "CONSIGNATÁRIOS",
    key: "/consignatarios",
    path: "/consignatarios",
    icon: <UserOutlined />,
    children: [
      {
        label: "CARTEIRA DOS CONSIGNATÁRIOS",
        key: "/lancamentoConsignatario",
        path: "/lancamentoConsignatario",
      },
      {
        label: "CONTROLE DE COMPROVANTES DOS CONSIGNATÁRIOS",
        key: "/controleComprovanteConsignatario",
        path: "/controleComprovanteConsignatario",
      },
      {
        label: "IMPORTAÇÃO DAS VENDAS DOS CONSIGNATÁRIOS",
        key: "/importacaoVendaConsignatario",
        path: "/importacaoVendaConsignatario",
      },
      {
        label: "SALDO CONSIGNATÁRIOS",
        key: "/relatorioSaldoConsignatario",
        path: "/relatorioSaldoConsignatario",
      },
      {
        label: "CRÉDITOS DOS CONSIGNATÁRIOS",
        key: "/relatorioCreditosConsignatario",
        path: "/relatorioCreditosConsignatario",
      },
      {
        label: "NOTAS FISCAIS",
        key: "/notasFiscais",
        path: "/notasFiscais",
      },
    ],
  },
  {
    label: "GERAL",
    key: "/geral",
    path: "/geral",
    icon: <FileProtectOutlined />,
    children: [
      {
        label: "CONSIGNATÁRIOS",
        key: "/consignatario",
        path: "/consignatario",
      },
    ],
  },
];
